module.exports = __webpack_public_path__ + "static/media/icon-default.b909c6bb.png";